<div class="payment_summary">
  <div class="payment_summary__header">
    <fa-icon
      [icon]="_iconHeader"
      class="payment_summary__checkmark-icon"
    ></fa-icon>
    <h3 class="form-field__summary-label">
      {{ field.label | translateInline }}
    </h3>
  </div>

  @if (htmlContent$ | async; as content) {
    <div
      class="form-field__summary payment_summary__body"
      [innerHTML]="content"
    ></div>
  }
</div>
